import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withNavigationErrorHandler } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { ngswBypassInterceptor } from './app/interceptors/ngsw-bypass.interceptor';
import { installChunkErrorRecovery, isChunkLoadError, recoverFromChunkError } from './app/utils/chunk-error-recovery';
import { isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideServiceWorker } from '@angular/service-worker';

// Ensure base tag exists and has correct href to prevent "Invalid base URL" errors
// This is needed for Ionic's getAssetPath function to work correctly
// The base tag should already exist in index.html, but we ensure it's valid
// Run this synchronously before any other code to ensure base tag is set before Ionic loads
(function ensureBaseTag(): void {
  // Check if base tag exists and is valid
  let baseTag = document.querySelector('base');
  
  if (!baseTag) {
    // Create base tag if it doesn't exist
    baseTag = document.createElement('base');
    baseTag.href = '/';
    // Insert at the beginning of head to ensure it's processed first
    if (document.head.firstChild) {
      document.head.insertBefore(baseTag, document.head.firstChild);
    } else {
      document.head.appendChild(baseTag);
    }
  } else {
    // Ensure href is valid - if empty or invalid, set to '/'
    const href = baseTag.getAttribute('href');
    if (!href || href.trim() === '' || href === 'undefined' || href === 'null') {
      baseTag.setAttribute('href', '/');
    }
  }
  
  // Double-check that base tag is valid before proceeding
  const finalHref = baseTag.getAttribute('href');
  if (!finalHref || finalHref.trim() === '') {
    baseTag.setAttribute('href', '/');
  }
})();

// Outdated app files (chunks that no longer exist on the server): clean up and reload once instead of a white page
installChunkErrorRecovery();

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      mode: 'ios'
    }),
    provideHttpClient(withInterceptors([ngswBypassInterceptor])),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withNavigationErrorHandler((navigationError) => {
        if (isChunkLoadError(navigationError.error)) {
          void recoverFromChunkError();
        }
      })
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register immediately to detect updates as early as possible
      // This ensures updates are detected quickly, not after 30 seconds
      registrationStrategy: 'registerImmediately'
    }),
  ],
});
